import { store } from 'store';
import * as selectors from 'shared/features/auth/auth.selectors';

/**
 *
 * FIXME Don't use this file. Only legacy components use it
 *
 * If you won't to get current auth state use auth.selectors
 *
 */

export const loggedIn = () => {
  const state = store.getState();
  return Boolean(selectors.getUserAuthenticatedState(state));
};

/**
 *
 * Don't use it. This function was created just for the legacy utils.
 * If you want to get current auth state, use selectors inside your componentF
 *
 * Don't use it inside your actions/reducers/selectors! It will cause dependency cycle
 *
 */
export const getJWTToken = () => {
  const state = store.getState();
  return selectors.getJWTToken(state);
};

export default {
  loggedIn
};
